import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Infinite from 'react-list';
import { parseISO, isBefore, isEqual } from 'date-fns';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Grid } from '../../../components';

import RepVisit from './RepVisit';

import messages from './messages';
import './styles.css';

class RepVisits extends React.Component {
  static propTypes = {
    userData: PropTypes.object,
    scid: PropTypes.number,
    visits: PropTypes.object.isRequired,
  };

  state = {
    repVisits: [],
  };

  componentDidMount() {
    if (!this.props.visits || !this.props.visits.fetchCollegeVisits) return;
    this.fetchCollegeVisits();
  }

  fetchCollegeVisits = () => {
    this.props.visits.fetchCollegeVisits(this.props.scid).then((resp) => {
      resp.data.sort((a, b) => {
        const dateA = parseISO(a.visitDate);
        const dateB = parseISO(b.visitDate);
        if (isEqual(dateA, dateB)) return 0;
        return isBefore(dateA, dateB) ? -1 : 1;
      });
      this.setState({ repVisits: resp.data });
    });
  };

  renderVisit = (index, key) => {
    const {
      userData,
      visits: { registrationStatus, register, cancelRegistration },
      highschool: {
        timezoneName,
        options: { canSignupVisits },
      },
    } = this.props;
    const { repVisits } = this.state;
    const visit = repVisits[index];

    return (
      <Grid.Row key={key} className="visit-row" data-cy="visit-row">
        <RepVisit
          visit={visit}
          registrationStatus={registrationStatus}
          register={register}
          cancelRegistration={cancelRegistration}
          userData={userData}
          canSignupVisits={canSignupVisits}
          timezoneName={timezoneName}
        />
      </Grid.Row>
    );
  };

  render() {
    const schoolName = get(
      this.props.collegeData,
      'fullProfile.overview.schoolName.value',
      '',
    );
    const { repVisits } = this.state;
    return (
      <>
        {repVisits.length > 0 ? (
          <div className="repvisits-container" name="visits">
            <h2 className="upcoming-visits-header">
              <FormattedMessage
                {...messages.visiting}
                values={{ collegeName: schoolName }}
              />
            </h2>
            <div className="visits-list">
              <Infinite
                length={repVisits.length}
                minSize={5}
                pageSize={5}
                itemRenderer={this.renderVisit}
                useTranslate3d
              />
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default injectIntl(RepVisits);
